<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="创建人编码" prop="creator">
        <el-input v-model="form.creator" placeholder="请输入创建人编码" v-trim/>
      </el-form-item>
      <el-form-item label="创建时间" prop="createDate">
        <el-date-picker v-model="form.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="更新人编码" prop="editor">
        <el-input v-model="form.editor" placeholder="请输入更新人编码" v-trim/>
      </el-form-item>
      <el-form-item label="更新时间" prop="editDate">
        <el-date-picker v-model="form.editDate" value-format="yyyy-MM-dd" placeholder="请输入更新时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="是否删除0否 1是" prop="isdeleted">
        <el-input v-model="form.isdeleted" placeholder="请输入是否删除0否 1是" v-trim/>
      </el-form-item>
      <el-form-item label="所属分类编（关联category)" prop="categoryId">
        <el-input v-model="form.categoryId" placeholder="请输入所属分类编（关联category)" v-trim/>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="form.remark" placeholder="请输入备注" v-trim/>
      </el-form-item>
      <el-form-item label="状态 0待确认/待初审 1待分配/待终审 2待处理  3 已撤回 4已处理" prop="status">
        <el-input v-model="form.status" placeholder="请输入状态 0待确认/待初审 1待分配/待终审 2待处理  3 已撤回 4已处理" v-trim/>
      </el-form-item>
      <el-form-item label="排序码" prop="sortnum">
        <el-input v-model="form.sortnum" placeholder="请输入排序码" v-trim/>
      </el-form-item>
      <el-form-item label="类型 0位置责任人 1班长 2物业主管 3工程师 4SHE负责人 5SHE工单邮箱抄送人" prop="type">
        <el-input v-model="form.type" placeholder="请输入类型 0位置责任人 1班长 2物业主管 3工程师 4SHE负责人 5SHE工单邮箱抄送人" v-trim/>
      </el-form-item>
      <el-form-item label="上报人员编码（关联member)" prop="memberId">
        <el-input v-model="form.memberId" placeholder="请输入上报人员编码（关联member)" v-trim/>
      </el-form-item>
      <el-form-item label="部门编码" prop="companyId">
        <el-input v-model="form.companyId" placeholder="请输入部门编码" v-trim/>
      </el-form-item>
      <el-form-item label="上报时间" prop="submitDate">
        <el-input v-model="form.submitDate" placeholder="请输入上报时间" v-trim/>
      </el-form-item>
      <el-form-item label="SHE涉及人员类型 0本人 1同事 2供应商" prop="memberType">
        <el-input v-model="form.memberType" placeholder="请输入SHE涉及人员类型 0本人 1同事 2供应商" v-trim/>
      </el-form-item>
      <el-form-item label="SHE涉及人员企业编码集合" prop="memberQwids">
        <el-input v-model="form.memberQwids" placeholder="请输入SHE涉及人员企业编码集合" v-trim/>
      </el-form-item>
      <el-form-item label="SHE涉及人员供应商集合" prop="memberNames">
        <el-input v-model="form.memberNames" placeholder="请输入SHE涉及人员供应商集合" v-trim/>
      </el-form-item>
      <el-form-item label="发生地点/位置编码（关联category）" prop="localtionId">
        <el-input v-model="form.localtionId" placeholder="请输入发生地点/位置编码（关联category）" v-trim/>
      </el-form-item>
      <el-form-item label="是否外部就医 0否 1是" prop="outJiuyi">
        <el-input v-model="form.outJiuyi" placeholder="请输入是否外部就医 0否 1是" v-trim/>
      </el-form-item>
      <el-form-item label="是否医务室 0否 1是" prop="isYiwushi">
        <el-input v-model="form.isYiwushi" placeholder="请输入是否医务室 0否 1是" v-trim/>
      </el-form-item>
      <el-form-item label="是否受伤 0否 1是" prop="isHurted">
        <el-input v-model="form.isHurted" placeholder="请输入是否受伤 0否 1是" v-trim/>
      </el-form-item>
      <el-form-item label="是否和工作相关" prop="workRelated">
        <el-input v-model="form.workRelated" placeholder="请输入是否和工作相关" v-trim/>
      </el-form-item>
      <el-form-item label="事件说明" prop="eventInfo">
        <el-input v-model="form.eventInfo" placeholder="请输入事件说明" v-trim/>
      </el-form-item>
      <el-form-item label="邮件通知人员编码集合" prop="emialMemberIds">
        <el-input v-model="form.emialMemberIds" placeholder="请输入邮件通知人员编码集合" v-trim/>
      </el-form-item>
      <el-form-item label="企业微信通知人员编码集合" prop="qwnoticeMemberIds">
        <el-input v-model="form.qwnoticeMemberIds" placeholder="请输入企业微信通知人员编码集合" v-trim/>
      </el-form-item>
      <el-form-item label="发现时间" prop="happenTime">
        <el-input v-model="form.happenTime" placeholder="请输入发现时间" v-trim/>
      </el-form-item>
      <el-form-item label="风险类型(关联category）" prop="typeId">
        <el-date-picker v-model="form.typeId" value-format="yyyy-MM-dd" placeholder="请输入风险类型(关联category）"></el-date-picker>
      </el-form-item>
      <el-form-item label="风险描述" prop="riskInfo">
        <el-input v-model="form.riskInfo" placeholder="请输入风险描述" v-trim/>
      </el-form-item>
      <el-form-item label="当前物业主管编码（关联member）" prop="managerId">
        <el-input v-model="form.managerId" placeholder="请输入当前物业主管编码（关联member）" v-trim/>
      </el-form-item>
      <el-form-item label="当前处理人员编码（关联member)" prop="dealerId">
        <el-input v-model="form.dealerId" placeholder="请输入当前处理人员编码（关联member)" v-trim/>
      </el-form-item>
      <el-form-item label="分配时间" prop="dispatchTime">
        <el-date-picker v-model="form.dispatchTime" value-format="yyyy-MM-dd" placeholder="请输入分配时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="分配备注" prop="dispatchInfo">
        <el-input v-model="form.dispatchInfo" placeholder="请输入分配备注" v-trim/>
      </el-form-item>
      <el-form-item label="处理时间" prop="dealTime">
        <el-date-picker v-model="form.dealTime" value-format="yyyy-MM-dd" placeholder="请输入处理时间"></el-date-picker>
      </el-form-item>
      <el-form-item label="处理备注" prop="dealInfo">
        <el-input v-model="form.dealInfo" placeholder="请输入处理备注" v-trim/>
      </el-form-item>
      <el-form-item label="DCA问题编码" prop="problemId">
        <el-input v-model="form.problemId" placeholder="请输入DCA问题编码" v-trim/>
      </el-form-item>
      <el-form-item label="DCA问题数量" prop="problemNum">
        <el-input v-model="form.problemNum" placeholder="请输入DCA问题数量" v-trim/>
      </el-form-item>
      <el-form-item label="位置地点路径名称" prop="locationName">
        <el-input v-model="form.locationName" placeholder="请输入位置地点路径名称" v-trim/>
      </el-form-item>
      <el-form-item label="工单号" prop="code">
        <el-input v-model="form.code" placeholder="请输入工单号" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaWorkorderWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        creator: '',
        createDate: '',
        editor: '',
        editDate: '',
        isdeleted: '',
        categoryId: '',
        remark: '',
        status: '',
        sortnum: '',
        type: '',
        memberId: '',
        companyId: '',
        submitDate: '',
        memberType: '',
        memberQwids: '',
        memberNames: '',
        localtionId: '',
        outJiuyi: '',
        isYiwushi: '',
        isHurted: '',
        workRelated: '',
        eventInfo: '',
        emialMemberIds: '',
        qwnoticeMemberIds: '',
        happenTime: '',
        typeId: '',
        riskInfo: '',
        managerId: '',
        dealerId: '',
        dispatchTime: '',
        dispatchInfo: '',
        dealTime: '',
        dealInfo: '',
        problemId: '',
        problemNum: '',
        locationName: '',
        code: ''
      },
      // 验证规则
      rules: {
      }
    }
  },
  created () {
    this.config({
      api: '/business/workorder',
      'field.id': 'id'
    })
  }
}
</script>
